import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

@Component({
    selector: 'app-invoice-document-cell-renderer',
    standalone: true,
    imports: [CommonModule],
    template: `
                                                    <ng-container *ngIf="params?.data?.invoiceDocument as doc;else noInvoice">
                                                        <ng-container *ngIf="doc.serial && doc.externalDocument; else singleOrNone">
                                                            {{ doc.serial }}<br>{{ doc.externalDocument }}
                                                        </ng-container>
                                                        <ng-template #singleOrNone>
                                                            {{ doc.serial || doc.externalDocument || '-' }}
                                                        </ng-template>
                                                    </ng-container>
                                                    <ng-template #noInvoice>-</ng-template>
  `,
})
export class InvoiceDocumentLogisticCellRendererComponent implements CellRenderer<any> {
    @Input() params!: CellRendererParams<any>;
}
